(function (angular) {
	'use strict';

	var pinnedFeatureObject = {
		templateUrl: ['STATIC_BASE_PATH', templateUrlFunction],
		controller: [
			'APP_BASE_PATH',
			'Big',
			'featuresFactory',
			'urlFactory',
			PinnedFeatureFunction
		],
		controllerAs: 'pinnedFeature'
	};

	angular
		.module('featuresModule')
		.component('pinnedFeature', pinnedFeatureObject);

	function templateUrlFunction(STATIC_BASE_PATH) {
		return STATIC_BASE_PATH + '/static/html/features/components/pinned-feature.html';
	}

	function PinnedFeatureFunction(
		APP_BASE_PATH,
		Big,
		featuresFactory,
		urlFactory
	) {

		var pinnedFeature = this;

		function getFeature(){
			return featuresFactory.getPinnedFeature().then(function(feature){
				pinnedFeature.currentFeature = feature;
			});
		}

		function configureFeature(){
			if(pinnedFeature.currentFeature && pinnedFeature.currentFeature.accountFeatureDetails){
				pinnedFeature.principalInvested = pinnedFeature.currentFeature.accountFeatureDetails.principalInvestedToDate;
				pinnedFeature.upgradeThreshold = pinnedFeature.currentFeature.accountFeatureDetails.upgradeThreshold;
				pinnedFeature.amountNeededToUpgrade = pinnedFeature.currentFeature.accountFeatureDetails.amountNeededToUpgrade;
				pinnedFeature.daysWaivedForUserInvite = pinnedFeature.currentFeature.accountFeatureDetails.daysWaivedForUserInvite;
				pinnedFeature.currentFeature.ctaLink = urlFactory.serializeParamsAndCreateUrl(APP_BASE_PATH + pinnedFeature.currentFeature.ctaLink, {
					cta: 'Pinned Feature'
				});
				pinnedFeature.serviceLevelFeature = angular.isDefined(pinnedFeature.currentFeature.accountFeatureDetails.amountNeededToUpgrade);

				if(pinnedFeature.serviceLevelFeature) {
					pinnedFeature.locked = Big(pinnedFeature.principalInvested).lt(Big(pinnedFeature.upgradeThreshold));
				}
			}
		}

		pinnedFeature.$onInit = function(){
			getFeature().then(configureFeature);
		};

		pinnedFeature.dismiss = function() {
			featuresFactory.dismiss(pinnedFeature.currentFeature);
		};
	}
})(window.angular);